// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"5cb30eac","309":"7cf4f077","378":"980c0f49","473":"5e2a5924","620":"8fbc5069","661":"6645c0a9","771":"cf002845","817":"2d7181bc","855":"f6cb1420","934":"7282a0dd"}[chunkId] + ".chunk.js";
};